import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
import { useLinkChart } from './useLinkChart'
import { GetChartLinkResponse } from '../../../../../app/services/selfHireService/getChartLink'
import { Skeleton } from '@/view/components/ui/skeleton'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
)

interface LinkChartProps {
  data: GetChartLinkResponse | undefined
  isLoading: boolean
}

export const LinkChart = ({ data, isLoading }: LinkChartProps) => {
  const { data: graphData, options } = useLinkChart(data)

  return (
    <div className="w-full">
      {isLoading ? (
        <Skeleton className="h-[280px] w-full" />
      ) : (
        <div className="h-[280px] w-full">
          <Line options={options} data={graphData} plugins={[Filler]} />
        </div>
      )}
    </div>
  )
}
